module.exports = __webpack_public_path__ + "img/legumes_du_chef.560b29df.png";